import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormInput, FormSelect } from 'semantic-ui-react'
import { inject, observer } from 'mobx-react'
import FormEntry from '../../../models/FormEntry'

@inject('eventsStore')
@observer
class Select extends Component {
  static propTypes = {
    ...FormSelect.propTypes,
    options: FormSelect.propTypes.options,
    formEntry: PropTypes.instanceOf(FormEntry).isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    defaultValue: PropTypes.any,
    errorPointing: PropTypes.oneOf(['below', 'above', 'left']),
    castValue: PropTypes.func, // could be useful if you want to cast a value entered
    parseValue: PropTypes.func, // could be useful if you want to parse value to form value
    onAfterChanged: PropTypes.func,
    isFixed: PropTypes.bool,
    isRequired: PropTypes.bool
  }

  static defaultProps = {
    errorPointing: 'above',
    isFixed: false,
    isRequired: false
  }

  static defaultOptions = [
    { value: 'na', text: 'N/a', key: `na_${name}` },
    { value: 'nd', text: 'N/d', key: `nd_${name}` }
  ]

    handleOnChangeInput = (e, data) => {
      const { formEntry, castValue, onAfterChanged, isFixed } = this.props
      const value = castValue ? castValue(data.value) : data.value
      formEntry.updateValue(data.name, value, isFixed)
      if (onAfterChanged) {
        onAfterChanged(data.name, value)
      }
    }

    handleOnBlur = (e, data) => {
      const { label, onBlur, formEntry, eventsStore } = this.props
      if (onBlur) {
        onBlur(label, data.name, data.value)
      } else {
        if (['nonconforme', 'commentaire', 'replacer'].includes(data.value)) {
          eventsStore.addNFPA(formEntry.id, label, data.name, data.value)
        } else {
          eventsStore.removeNFPA(formEntry.id, data.name)
        }
      }
    }

    render () {
      const {
        formEntry,
        defaultValue,
        name,
        options,
        onChange,
        castValue,
        parseValue,
        errorPointing,
        error,
        readOnly,
        onAfterChanged,
        isFixed,
        isRequired,
        onBlur,
        eventsStore,
        ...props
      } = this.props
      const value = formEntry.getValue(name, isFixed, defaultValue !== undefined ? defaultValue : options[0].value)
      const hasError = formEntry.getError(name)
      if (formEntry.readonly) {
        const _value = parseValue ? parseValue(value) : value
        const _option = [...options, ...Select.defaultOptions].find(option => option.value === _value)
        return <FormInput transparent {...props} readOnly value={_option ? _option.text : ''} />
      }
      return (
        <FormSelect
          options={[...options, ...Select.defaultOptions]}
          value={parseValue ? parseValue(value) : value}
          name={name}
          error={hasError}
          onChange={onChange || this.handleOnChangeInput}
          onBlur={this.handleOnBlur}
          {...props}
        />
      )
    }
}
export default Select
